import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import useNav from '../../application/hooks/useNav';
import { useBaseParam } from '../../application/hooks/useBaseParam';
import { HOME_TABS } from '../../application/staticData/home/HOME_TABS';
import * as Atom from '../../application/recoil';
import { getCustPreProductList } from '../../infra/api/getCustPreProductList';
import { Popup, SegmentButtons } from 'oui';
import { DefaultBox } from '../etc/LBox/LBox';
import CreditLanding from './CreditLanding';
import MtgLanding from './Mtg/MtgLanding';
import eventTimer from '../../application/helper/eventTimer';
import { IS_MTG_EXPOSED, PAGE_NM } from '../../application/types/types';

const Home = () => {
  const { navigate } = useNav();
  const { media } = useParams();
  const [personal] = useRecoilState(Atom.personalInfo);
  const [landingInfo, setLandingInfo] = useRecoilState(Atom.loanList);
  const [homeTab, setHomeTab] = useRecoilState(Atom.homeTab);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isMaintenancePopupOpen, setIsMaintenancePopupOpen] =
    useState<boolean>(false);

  const fetchCustLoanList = useBaseParam(getCustPreProductList, {
    custSeq: personal.custSeq,
  });

  const navigateMainPage = async () => {
    if (personal.custSeq) {
      const res = await fetchCustLoanList();
      const list = res?.data?.result;
      setLandingInfo(list);
    }

    // if (list?.dayAgo === 0 && list?.preRequestInfoChk === true) {
    //   navigate('/main/result-entry', { replace: true });
    //   setIsLoading(false);
    // } else {
    //   navigate('/main', { replace: true });
    //   setIsLoading(false);
    // }
    navigate('/main', { replace: true });
    setIsLoading(false);
  };

  const getIsLguMaintenance = () => {
    if (media !== 'lgu') {
      return false;
    }

    return eventTimer(
      process.env.REACT_APP_LGU_MAINTENANCE_START || '',
      process.env.REACT_APP_LGU_MAINTENANCE_END || '',
      new Date().toISOString(),
    );
  };

  const isLguMaintenance = getIsLguMaintenance();

  // todo 이상하다..
  useEffect(() => {
    if (personal.custSeq !== '') {
      navigateMainPage();
    }
  }, [personal.custSeq]);

  useEffect(() => {
    if (isLguMaintenance) {
      setIsMaintenancePopupOpen(true);
    }
  }, [isLguMaintenance]);

  useEffect(() => {
    if (!IS_MTG_EXPOSED && homeTab === PAGE_NM.MTG_HOME) {
      setHomeTab(PAGE_NM.HOME);
    }
  }, [homeTab, setHomeTab]);

  if (isLoading) return null;

  const currentHomeTab =
    !IS_MTG_EXPOSED && homeTab === PAGE_NM.MTG_HOME ? PAGE_NM.HOME : homeTab;
  const shouldShowHomeTabs = HOME_TABS.length > 1;

  return (
    <>
      {shouldShowHomeTabs && (
        <DefaultBox verticalGap={8}>
          <SegmentButtons
            items={HOME_TABS}
            activeIdx={HOME_TABS.findIndex(
              (item) => item.value === currentHomeTab,
            )}
            varient="b"
            onClickButton={(_, { index }) => setHomeTab(HOME_TABS[index].value)}
          />
        </DefaultBox>
      )}
      {currentHomeTab === PAGE_NM.MTG_HOME ? <MtgLanding /> : <CreditLanding />}
      <Popup
        title="서비스 점검 안내"
        description="2026/3/11(수) 02:00~04:00 동안<br>시스템 작업으로 이용이 일시 중단됩니다."
        isPopupOpen={isMaintenancePopupOpen}
        confirmBtn={{
          text: '확인',
          onClick: () => {
            setIsMaintenancePopupOpen(false);
          },
        }}
      />
    </>
  );
};

export default Home;
